export const getInitialFileToUploadPayload = (id: string, name: string, size: number, cancelRequest: () => void) => ({
  id,
  name,
  size,
  percentage: 0,
  status: 'uploading',
  cancelRequest,
});
